export default __webpack_public_path__ + "static/media/marketplace-no-data.0b934197.svg";